import { PaginationWrapper } from './PaginationWrapper';

export default PaginationWrapper;
